<div class="card-container" #container>
    <div class="card-header-wrapper">
        <h3 class="card-title"> {{ customMsgService.translate('movimentos') }} </h3>
        <span></span>

    </div>

    <div class="card-component">

        <kendo-grid [kendoGridBinding]="gridView" kendoGridSelectBy="id" [selectedKeys]="mySelection" [pageSize]="50"
            [pageable]="true" [sortable]="true" [groupable]="true" [filterable]="true" [reorderable]="true"
            [resizable]="true" [height]="690" [columnMenu]="{ filter: true }" (filterChange)="filterChange($event)">
            <ng-template kendoGridToolbarTemplate>
                <kendo-textbox [placeholder]="customMsgService.translate('gridSearch')" kendoTextBox
                    style="width: 230px;" (valueChange)="onFilter($event)">
                </kendo-textbox>

                <form class="k-form k-form-horizontal"
                    style="max-width: 200px;width: 200px; display: flex; justify-content: space-between;"
                    [formGroup]="formGroup">
                    <kendo-formfield orientation="horizontal">
                        <kendo-label class="k-label" [for]="dataDe" [text]="customMsgService.translate('de')">
                        </kendo-label>
                        <kendo-datepicker formControlName="dataDe" #dataDe></kendo-datepicker>
                    </kendo-formfield>

                </form>

                <form class="k-form k-form-horizontal"
                    style="max-width: 350px;width: 350px; display: flex; justify-content: space-between;"
                    [formGroup]="formGroup">

                    <kendo-formfield orientation="horizontal">
                        <kendo-label class="k-label" [for]="dataAte" [text]="customMsgService.translate('ate')">
                        </kendo-label>
                        <kendo-datepicker formControlName="dataAte" #dataAte></kendo-datepicker>
                    </kendo-formfield>


                    <button kendoButton (click)="pesquisar()" themeColor="primary">
                        {{customMsgService.translate('filtrarEntreDatas')}} </button>

                </form>



                <kendo-grid-spacer></kendo-grid-spacer>
                <button kendoGridExcelCommand type="button" [title]="customMsgService.translate('btnExportarExcel')"
                    icon="file-excel" themeColor="warning">
                </button>
                <button kendoGridPDFCommand icon="file-pdf" [title]="customMsgService.translate('btnExportarPDF')"
                    themeColor="warning"> </button>
            </ng-template>
            <kendo-grid-column field="nomeFerramenta" [title]="customMsgService.translate('identificacao')"
                [width]="75">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="customer-name"> {{ dataItem.nomeFerramenta }} </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="nomeUtilizador" [title]="customMsgService.translate('user')" [width]="130">
                <ng-template kendoGridCellTemplate let-dataItem>

                    <div class="customer-name"> {{ dataItem.nomeUtilizador }} </div>
                </ng-template>

            </kendo-grid-column>

            <kendo-grid-column field="codigoFuncionario" [title]="customMsgService.translate('employeeCode')"
                [width]="80">
                <ng-template kendoGridCellTemplate let-dataItem>

                    <div class="customer-name"> {{ dataItem.codigoFuncionario }} </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="data" [title]="customMsgService.translate('movDataHora')" [width]="130">
                <ng-template kendoGridCellTemplate let-dataItem>

                    <div class="customer-name"> {{ dataItem.data | date:"dd-MM-yyyy HH:mm:ss" }} </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="nomeCompartimento" [title]="customMsgService.translate('nomeCompartimento')"
                [width]="60">
                <ng-template kendoGridCellTemplate let-dataItem>

                    <div class="customer-name"> {{ dataItem.nomeCompartimento }} </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="nomeArmario" [title]="customMsgService.translate('numArmario')" [width]="80">
                <ng-template kendoGridCellTemplate let-dataItem>

                    <div class="customer-name"> {{ dataItem.nomeArmario }} </div>
                </ng-template>
            </kendo-grid-column>


            <kendo-grid-column field="avariadaString" [title]="customMsgService.translate('avaria')" [width]="70">
                <ng-template kendoGridCellTemplate let-dataItem>

                    <div class="customer-name"> {{ dataItem.avariadaString }} </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="estadoString" [title]="customMsgService.translate('state')" [width]="90">
                <ng-template kendoGridCellTemplate let-dataItem>

                    <div class="customer-name"> {{ dataItem.estadoString }} </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-pdf fileName="{{customMsgService.translate('movimentos')}}.pdf" [repeatHeaders]="true"
                [allPages]="true" paperSize="A4" [landscape]="true" [scale]="0.6">
                <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
                <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
                    <div class="page-template">
                        <div class="header">
                            <div style="float: left">
                                {{ customMsgService.translate('movimentos') }}
                            </div>
                        </div>
                        <div class="footer">{{ customMsgService.translate('pagina') }} {{ pageNum }} {{
                            customMsgService.translate('de_') }} {{ totalPages }}</div>
                    </div>
                </ng-template>

                <kendo-grid-column field="nomeFerramenta" [title]="customMsgService.translate('identificacao')">
                </kendo-grid-column>

                <kendo-grid-column field="nomeUtilizador" [title]="customMsgService.translate('user')">
                </kendo-grid-column>

                <kendo-grid-column field="codigoFuncionario" [title]="customMsgService.translate('employeeCode')">
                </kendo-grid-column>

                <kendo-grid-column field="data" filter="date" [title]="customMsgService.translate('movDataHora')">
                </kendo-grid-column>

                <kendo-grid-column field="nomeCompartimento" [title]="customMsgService.translate('nomeCompartimento')">
                </kendo-grid-column>

                <kendo-grid-column field="nomeArmario" [title]="customMsgService.translate('numArmario')">
                </kendo-grid-column>

                <kendo-grid-column field="avariadaString" [title]="customMsgService.translate('avaria')">
                </kendo-grid-column>

                <kendo-grid-column field="estadoString" [title]="customMsgService.translate('state')">
                </kendo-grid-column>

            </kendo-grid-pdf>

            <kendo-grid-excel [fetchData]="allData" fileName="{{customMsgService.translate('movimentos')}}.xlsx">
            </kendo-grid-excel>

        </kendo-grid>
    </div>
</div>
<div kendoDialogContainer></div>